<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled'
                                    : props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Enter Code"
                  v-model="accountType.code"
                  type="text"
                  :rules="rules.accountTypeCodeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="accountTypeName"
                  label="Enter Account Type Name"
                  v-model="accountType.accTypeName"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="natureList"
                  label="Nature"
                  v-model="accountType.accTypeNature"
                  item-text="label"
                  item-value="value"
                  :rules="rules.accountTypeNatureRules"
                ></v-select>
              </v-flex>
              <!-- <v-flex sm6>
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex> -->
              <v-flex sm12 v-if="accountType.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
                </v-flex>
                <v-flex sm12 v-if="accountType.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="accountType.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="accountType.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="accountType.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="accountType.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
import { AccountType } from "../../models/model";
import { AccountTypeFormRules } from "../../helpers/validation-rules";
import { accountTypeService } from "../../services/account-type-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
export default {
  name: "AccountTypeDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Account Type",
        disabled: false,
        to: "account-types"
      },
      {
        text: "Account Type Detail",
        disabled: true
      }
    ],
    natureList: [
      { label: "BS", value: "BS" },
      { label: "IS", value: "IS" }
    ],
    statusFlag: true,
    responseError: "",
    updatedDate: "",
    createdDate: "",
    saveLoading: false,
    accountType: new AccountType(),
    oldAccountType: new AccountType(),
    rules: new AccountTypeFormRules()
  }),
  created() {
    const id = this.$route.params.id;
    console.log(id);
    if (id == "new") {
      // new accountHead
    } else {
      this.getAccountTypeDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;

        this.accountType.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        accountTypeService
          .saveAccountType(this.accountType)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    goBack() {
      this.$router.push("/account-types");
    },
    getAccountTypeDetail(id) {
      accountTypeService
        .getAccountTypeDetail(id)
        .then(res => {
          this.accountType = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.accountType.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.accountType.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.statusFlag = this.accountType.status == 'ACTIVE' ? true : false;
          this.oldAccountType = Object.assign({}, res.data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.accountType.id) {
        this.accountType = new AccountType();
        this.statusFlag = true;
      } else {
        this.accountType = Object.assign({}, this.oldAccountType);
        this.statusFlag = this.accountType.status == 'ACTIVE' ? true : false;
      }
    },
  }
}
</script>